import { configureStore, createSlice } from "@reduxjs/toolkit";

const initProfil = {
    _id: '',
    status: 'user',

    lastName: '',
    firstName: '',

    profession: '',
    mainLocation: '',
    secondaryLocations: [],
    
    proPhone: '',
    secretaryPhone: '',
    proEmail: '',
    secureProEmail: '',
    
    patientComTool: [],
    otherPatientComTool: '',
    adminComTool: [],
    otherAdminComTool: '',
    interproTool: [],
    otherInterproTool: '',
    meetingTool: [],
    otherMeetingTool: '',
    
    urgentContact: [],
    otherUrgentContact: '',
    dailyContact: [],
    otherDailyContact: '',
    weeklyContact: [],
    otherWeeklyContact: '',
    
    targetAudiences: [],
    otherTargetAudiences: '',
    importantInfo: '',
}

const profilSlice = createSlice({
    name: "profil",
    initialState: initProfil,
    reducers: {
        setProfil: (state, action) => {
            const newProfil = action.payload;
            state = newProfil === null ? initProfil : newProfil;
            return state;
        }
    }
})

export const { setProfil } = profilSlice.actions;

const messageSlice = createSlice({
    name: "message",
    initialState: '',
    reducers: {
        setMessage: (state, action) => {
            state = action.payload ? action.payload : '';
            return state;
        }
    }
})

export const { setMessage } = messageSlice.actions;

// ------------------------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------

export const store = configureStore({
    reducer: {
        profil: profilSlice.reducer,
        message: messageSlice.reducer,
    }
});